import _ from 'lodash';

import {
  OFFSET_LIMIT_500,
  SCRIPT_URI_ADDON,
  TABLE_URI_ADDON
} from '../../../constants/constant';
import {
  FETCH_ORDERS,
  FIELDS,
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import { getRequest, postRequest } from '../../Common/network-call';
import { ALLOWED_FEATURE_KEYS } from '../../../constants/section-constants/common-constants';
import { postAnalytics } from '../../../actions';
import { fetchGameChallengeStatus } from '../../gamification/actions';
import { showToast } from '../../Common/alertmessage';
import LocalStrings from '../../../assets/languages';
import { ALLOWED_POST_ANALYTICS_TYPES } from '../../../constants/section-constants/type-constants';
import { ALLOWED_GAME_CHALLENGE_TYPES } from '../../../constants/section-constants/gamification-constants';

export const MY_BOOKED_EXHIBITOR = 'MY_BOOKED_EXHIBITOR';
export const FETCH_EXHIBITORS = 'FETCH_EXHIBITORS';
export const SETEXHIBITORDETAILS = 'SETEXHIBITORDETAILS';
export const FETCH_EXHIBITOR_DETAILS = 'FETCH_EXHIBITOR_DETAILS';
export const FETCH_EXB_CHAT_DETAILS = 'FETCH_EXB_CHAT_DETAILS';
export const SHOW_ONLY_EXHIBITOR_DETAILS = 'SHOW_ONLY_EXHIBITOR_DETAILS';
export const FETCH_EXB_COUNTRY = 'FETCH_EXB_COUNTRY';
export const FETCH_EXB_SECTORS = 'FETCH_EXB_SECTORS';
export const FETCH_EXB_CATEGORIES = 'FETCH_EXB_CATEGORIES';
export const SIMPLE_CATEGORY_LIST = 'SIMPLE_CATEGORY_LIST';
export const FETCH_BY_FILTER = 'FETCH_BY_FILTER';
export const FETCH_BY_TAG = 'FETCH_BY_TAG';

export const fetchBookedExhibitors = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=exhibitor)`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}?include_count=true&fields=${FIELDS.bookmarks.minInfo}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        dispatch({
          type: MY_BOOKED_EXHIBITOR,
          payload: { resource: response.resource, count: response.meta.count }
        });
        callback({
          success: 1,
          resource: response.resource,
          count: response.meta.count
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchAllExhibitor = (session, middleWares, callback) => {
  // --- middleWares is a object that has all the surplus params
  let pageCount = middleWares?.pagecount ?? 0; // for offset calculation
  let actionType = middleWares?.type ?? ''; // 'search'/''/'country'/'industry'/'subcategory'/'redirection'/'filter'
  let searchTerm = middleWares?.term ?? ''; // keyword to search / country name / industry name / subcategory array
  let sortBy = middleWares?.sort ?? ''; // DEFAULT 'az'(name) / 'randomly'(create) / 'booth'
  let dataArr = middleWares?.data ?? []; // previous fetched collection to concat upon
  let reRender = middleWares?.rerender ?? false; // true if re-render of list needed
  let selectedExhibitorId = middleWares?.id ?? null; // bookmarked / selected exhibitor id to filter
  let chunkDataArr =
    reRender && middleWares?.data?.length ? _.chunk(middleWares?.data, 20) : [];
  let bookmarkAction = middleWares?.action ?? ''; // bookmark action
  let categorieslist = middleWares?.category ?? ''; // for filtering id
  let tagCall = middleWares?.callFromTag ?? false; // for checked wheather called from filter or tag

  // --- pagination handling
  let perPage = OFFSET_LIMIT_500;
  if (reRender && selectedExhibitorId && chunkDataArr.length) {
    _.map(chunkDataArr, (chunkItem, chunkIndex) => {
      let filterChunk = _.filter(
        chunkItem,
        exhItem => exhItem.exhibitorid == selectedExhibitorId
      );

      if (filterChunk.length) pageCount = chunkIndex + 1;
    });
  }
  let offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  let offSetQuery = `limit=${perPage}&offset=${offset}`;

  // --- param handling
  let fetchFilter = encodeURI(`eventid=${session.eventid}`);

  if (actionType == 'filter' && !_.isEmpty(searchTerm)) {
    const combine = list => {
      let inStr = '( ';
      _.map(list, (item, index) => {
        if (index == list.length - 1) {
          inStr += item + ' )';
        } else {
          inStr += item + ', ';
        }
      });
      return inStr;
    };
    let restCountry = '';
    let restIndustry = '';
    let restCategory = '';
    if (searchTerm?.country?.length > 0) {
      const countries = combine(searchTerm.country);
      restCountry = `AND(country IN ${countries})`;
    }
    if (searchTerm?.industry?.length > 0) {
      const industries = combine(searchTerm.industry);
      restIndustry = `AND(industry IN ${industries})`;
    }
    if (searchTerm?.category?.length > 0) {
      const categoryIDs = [];
      searchTerm.category.map(ea => {
        _.map(categorieslist, cate => {
          if (cate?.category === ea || cate?.subcategory === ea)
            categoryIDs.push(cate?.exhibitorid);
        });
      });
      const categories = combine(_.uniq(categoryIDs));
      restCategory = `AND(exhibitorid IN ${categories})`;
    }
    if (searchTerm?.options?.length > 0) {
      const exbitorid = combine(_.uniq(searchTerm?.options));
      restCategory = `AND(exhibitorid IN ${exbitorid})`;
    }

    fetchFilter = encodeURI(
      `(eventid=${session.eventid})${restCountry}${restIndustry}${restCategory}`
    );
    if (tagCall) actionType = '';
  } else if (searchTerm !== '') {
    fetchFilter =
      actionType == 'search'
        ? encodeURI(
            `(eventid=${session.eventid})AND((name CONTAINS ${searchTerm})OR(booth CONTAINS ${searchTerm}))`
          )
        : actionType == 'country'
        ? encodeURI(`(eventid=${session.eventid})AND(country=${searchTerm})`)
        : encodeURI(`(eventid=${session.eventid})AND(industry=${searchTerm})`);
  }

  let orderBy =
    (!_.isEmpty(actionType) && !_.isEqual(actionType, 'redirection')) ||
    _.isEqual(sortBy, 'az')
      ? FETCH_ORDERS.exhibitor.name
      : _.isEqual(sortBy, 'booth')
      ? FETCH_ORDERS.exhibitor.booth
      : FETCH_ORDERS.exhibitor.random;

  const related = !_.isEmpty(session?.sessionToken)
    ? `appuser_by_exhibitoridfk&appuser_by_exhibitoridfk.fields=${FIELDS.appuser.relatedInfo}`
    : '';

  let fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.exhibitors}?include_count=true&fields=${FIELDS.exhibitors.maxInfo}&related=${related}&filter=(${fetchFilter})&order=${orderBy}&${offSetQuery}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      response => {
        let responseArr = response.resource;

        // --- bookmark handling
        _.map(responseArr, (exhItem, resourceIndex) => {
          let itemObj = exhItem;

          // - if coming for rerender with selected item id setting key bool value acc. to action
          if (
            selectedExhibitorId &&
            exhItem.exhibitorid == selectedExhibitorId &&
            bookmarkAction != ''
          )
            itemObj.isBookMarked = bookmarkAction == 'unmark' ? false : true;
          else itemObj.isBookMarked = false;

          responseArr[resourceIndex] = itemObj;
        });

        // --- sorting for booth
        if (sortBy === 'booth') {
          let boothNos = _.filter(responseArr, obj => {
            return obj?.booth;
          });
          let notBooth = _.filter(responseArr, obj => {
            return !obj.booth || obj.booth == '';
          });
          if (notBooth.length > 0) {
            boothNos = _.concat(boothNos, notBooth);
          }
          responseArr = boothNos;
        }

        // --- redirection actionType section
        if (actionType == 'redirection' && selectedExhibitorId) {
          let filterExh = _.filter(
            responseArr,
            exh => exh.exhibitorid == selectedExhibitorId
          );
          dispatch(
            fetchExhibitorDetails(session, selectedExhibitorId, detailsRes => {
              if (detailsRes.details) {
                dispatch(setExhibitor(detailsRes.details));
                if (!filterExh.length)
                  responseArr = _.concat(detailsRes.details, responseArr);
              }
            })
          );
        }

        // --- payload creation and dispatches
        let payloadObj = {
          count: response.meta.count
        };
        if (reRender) {
          chunkDataArr[pageCount <= 1 ? 0 : pageCount - 1] = responseArr;
          payloadObj.resource = _.flatten(chunkDataArr);
        } else payloadObj.resource = dataArr.concat(responseArr);

        if (actionType == 'filter') {
          dispatch({
            type: FETCH_BY_FILTER,
            payload: payloadObj
          });
          // return true;
        } else if (tagCall) {
          dispatch({
            type: FETCH_BY_TAG,
            payload: payloadObj
          });
        } else {
          dispatch({
            type: FETCH_EXHIBITORS,
            payload: payloadObj
          });
        }

        callback({
          ...payloadObj,
          success: 1
        });
      },
      error => {
        callback({
          success: 0,
          message: error
        });
      }
    );
  };
};

export const fetchExhibitorDetails = (
  session,
  exhibitorid,
  callback = () => {}
) => {
  const url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.eventifyScript.exhibitorDetails.endpoint}`;
  let body = _.cloneDeep(SCRIPTS.eventifyScript.exhibitorDetails.payload);
  body.eventid = session.eventid;
  body.appuserid = session.userid;
  body.exhibitorid = exhibitorid;

  let table_filter = encodeURI(
    `(eventid=${session.eventid})AND(exhibitorid=${exhibitorid})`
  );
  let table_url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.exhibitors}?related=appuser_by_exhibitoridfk,interactivemaps_by_interactivemaplocation_exhibitor_link&filter=(${table_filter})`;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        getRequest(
          table_url,
          session,
          dispatch,
          res => {
            if (res.resource.length > 0) {
              dispatch({
                type: FETCH_EXHIBITOR_DETAILS,
                payload: { ...response.data, details: res.resource[0] }
              });
              callback &&
                callback({ ...response.data, details: res.resource[0] });
            } else {
              dispatch({
                type: FETCH_EXHIBITOR_DETAILS,
                payload: response.data
              });
              callback && callback(response.data);
            }

            // Post Analytics Data
            dispatch(
              postAnalytics(
                session,
                [
                  ALLOWED_POST_ANALYTICS_TYPES.screen.exhibitor,
                  ALLOWED_POST_ANALYTICS_TYPES.type.entry,
                  exhibitorid,
                  null,
                  0
                ],
                anaRes => {}
              )
            );

            // Gamification Status
            dispatch(
              fetchGameChallengeStatus(
                session,
                ALLOWED_GAME_CHALLENGE_TYPES.types.exhibitor,
                response => {
                  if (response.data && response.data.iscompleted == true) {
                    if (response.data.showpopup == true) {
                      response.data.challengetype =
                        ALLOWED_GAME_CHALLENGE_TYPES.types.exhibitor;
                      dispatch(setGamificationPopup(true, response.data));
                    } else if (response.data?.showpopup) {
                      showToast(
                        `${LocalStrings.dynamic.kYouHaveGot} ${response.data.points} ${LocalStrings.dynamic.kPointsText}`
                      );
                    }
                  }
                }
              )
            );
          },
          err => {
            dispatch({ type: FETCH_EXHIBITOR_DETAILS, payload: response.data });
            callback && callback(response.data);
          }
        );
      },
      error => {}
    );
  };
};

export const fetchExbCountry = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(country != '')AND(country != ${null})`
  );
  let groupby = 'country';
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.exhibitors}?include_count=true&fields=${FIELDS.exhibitors.minInfo}&filter=(${filter})&group=${groupby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_EXB_COUNTRY,
          payload: { data: data.resource, count: data.resource.length }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchExbSectors = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(industry != '')AND(industry != ${null})`
  );
  let groupby = 'industry';
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.exhibitors}?include_count=true&filter=(${filter})&group=${groupby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_EXB_SECTORS,
          payload: { data: data.resource, count: data.resource.length }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchExbCategories = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${
      session.eventid
    })AND(subcategory != '')AND(subcategory != ${null})`
  );

  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.exhibitorProducts}?include_count=true&fields=${FIELDS.exhibitors.mediumInfo}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        const groupByCategory = _.groupBy(data.resource, 'category');
        let groupByCategorySubCategory = [];
        for (const key in groupByCategory) {
          const value = groupByCategory[key];
          const groupBySubCategory = _.groupBy(value, 'subcategory');

          let subcategory = [];
          for (const keySubcategory in groupBySubCategory) {
            const valueSubcategory = groupBySubCategory[keySubcategory];

            let data = [];
            _.map(valueSubcategory, item => {
              data.push(item.exhibitorid);
            });

            subcategory.push({
              subcategory: keySubcategory,
              data: data
            });
          }

          groupByCategorySubCategory.push({
            category: key,
            subcategory: subcategory
          });
        }
        dispatch({
          type: SIMPLE_CATEGORY_LIST,
          payload: data.resource
        });
        dispatch({
          type: FETCH_EXB_CATEGORIES,
          payload: {
            data: groupByCategorySubCategory,
            count: groupByCategorySubCategory.length
          }
        });
        callback({
          success: 1,
          result: { response: groupByCategorySubCategory }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchExhibitorAnalytics = (
  session,
  extra = { type: '', id: 0 },
  callback
) => {
  if (_.isEmpty(extra?.type) || _.isNil(extra?.id))
    return dispatch =>
      callback({
        success: 0,
        error: 'Search type or id missing'
      });

  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${
    _.isEqual(ALLOWED_FEATURE_KEYS.exhibitor, extra?.type)
      ? SCRIPTS.analytics.exhibitorAllHits.endpoint
      : SCRIPTS.analytics.sponsorAllHits.endpoint
  }`;
  let body = _.cloneDeep(
    _.isEqual(ALLOWED_FEATURE_KEYS.exhibitor, extra?.type)
      ? SCRIPTS.analytics.exhibitorAllHits.payload
      : SCRIPTS.analytics.sponsorAllHits.payload
  );
  body.eventid = session.eventid;
  body.id = extra?.id;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({
          success: 1,
          data: response.result,
          message: response.message
        });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

// --- clear redux starts
export const clearAllExhibitor = () => {
  return dispatch => {
    dispatch({ type: FETCH_EXHIBITORS, payload: {} });
  };
};

export const clearExhibitorDetails = () => {
  return dispatch => {
    dispatch({ type: FETCH_EXHIBITOR_DETAILS, payload: {} });
  };
};
// --- clear redux ends

// --- set redux no call starts
export const setExhibitor = exhibitor => {
  return dispatch => {
    dispatch({ type: SETEXHIBITORDETAILS, payload: exhibitor });
  };
};

export const setAllExhibitor = allExhibitor => {
  return dispatch => {
    dispatch({ type: FETCH_EXHIBITORS, payload: allExhibitor });
  };
};

export const showOnlyExhibitorDetails = bool => {
  return dispatch => {
    dispatch({ type: SHOW_ONLY_EXHIBITOR_DETAILS, payload: bool });
  };
};
// --- set redux no call ends

export const fetchExhibitorListMinified = (session, fields, callback) => {
  let fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.exhibitors}?include_count=true&fields=${fields}&filter=(eventid=${session.eventid})`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        callback({
          success: 1,
          data: { count: res.meta.count, data: res.resource },
          error: null
        });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};

export const fetchSponsorListMinified = (session, fields, callback) => {
  let fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sponsor}?fields=${fields}&filter=(eventid=${session.eventid})`;
  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => callback({ success: 1, data: res.resource }),
      error => callback({ success: 0, data: null })
    );
  };
};

export const fetchDetailsByExhibitorId = (session, exhibitorId, callback) => {
  let fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.exhibitors}?filter=((eventid=${session.eventid})AND(exhibitorid=${exhibitorId}))`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      fetchRes => {
        callback({ success: 0, data: fetchRes.resource[0], error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};
